import { h } from "preact";
import { traceWidgetLoad } from "../internal_utilities/utilities";

const DeskShareOptions = ({
  isOpen,
  onClose,
  giftDetails,
  shareURL,
  currentLanguage,
  currentCampaign
}) => {
  console.log(isOpen);
  return (
    <div
      className={`coca-email-popup-wrapper absolute bg-black/10 flex flex-col w-full h-full items-stretch  ${
        isOpen
          ? "coca-form-visible opacity-100 pointer-events-auto transition"
          : "coca-form-invisible opacity-0 pointer-events-none transition"
      }`}
    >
      <a
        onClick={() => onClose()}
        className="coca-email-bg-close-area w-full opacity-0 p-0 m-0 grow bg-black/25"
      />
      <div
        className={`coca-email-popup rounded shadow-lg m-2 bg-white px-3 pt-4 transition -translate-y-40 ${isOpen &&
          "translate-y-0 pointer-events-auto"}`}
      >
        <div className="coca-referral-initial-cta px-4 py-3 font-bold grow-0 shrink-0 flex flex-col">
          {/* Twitter share */}
          <a
            onClick={() => {
              traceWidgetLoad({
                name: `clicked_twitter_share`,
                domain: window.Shopify.shop,
                url: window.location.href,
                referrer: document.referrer || "",
                key: ["app_name", "widget_type"],
                value: ["offerscorner", currentCampaign.type],
                operatingSystem: window.navigator.userAgentData
                  ? window.navigator.userAgentData.platform
                  : window.navigator.platform,
                screenSize: window.screen
                  ? `${window.screen.width}-${window.screen.height}`
                  : "",
                browserVersion: window.navigator.userAgentData
                  ? window.navigator.userAgentData.brands[0].version
                  : "",
                browser: window.navigator.userAgentData
                  ? window.navigator.userAgentData.brands[0].brand
                  : ""
              });
              window
                .open(
                  `https://twitter.com/intent/tweet?url=${shareURL}&text=Hey%20visit%20the%20following%20link%20to%20get%20a%20${giftDetails
                    .campaign.giftConfig.discountValue * -1}${
                    giftDetails.campaign.giftConfig.discountType ===
                    "percentage"
                      ? "%25"
                      : `%20${window.Shopify.currency.active}`
                  }%20discount`,
                  "_blank"
                )
                .focus();
            }}
            className=" coca-thank-big-button my-2 px-2 py-3 rounded-md text-center cursor-pointer text-base w-full"
            ref={node => {
              if (node)
                node.style.setProperty("background", `#1DAEFF`, "important");
            }}
          >
            <span
              ref={node => {
                if (node) node.style.setProperty("color", `white`, "important");
              }}
            >
              {" "}
              {currentLanguage && currentLanguage.share_on_twitter_text
                ? currentLanguage.share_on_twitter_text
                : "SHARE ON TWITTER"}
            </span>
          </a>
          {/* Facebook Share */}
          <a
            onClick={() => {
              traceWidgetLoad({
                name: `clicked_fb_share`,
                domain: window.Shopify.shop,
                url: window.location.href,
                referrer: document.referrer || "",
                key: ["app_name", "widget_type"],
                value: ["offerscorner", currentCampaign.type],
                operatingSystem: window.navigator.userAgentData
                  ? window.navigator.userAgentData.platform
                  : window.navigator.platform,
                screenSize: window.screen
                  ? `${window.screen.width}-${window.screen.height}`
                  : "",
                browserVersion: window.navigator.userAgentData
                  ? window.navigator.userAgentData.brands[0].version
                  : "",
                browser: window.navigator.userAgentData
                  ? window.navigator.userAgentData.brands[0].brand
                  : ""
              });
              window
                .open(
                  `https://www.facebook.com/sharer/sharer.php?u=${shareURL}`,
                  "_blank"
                )
                .focus();
            }}
            className=" coca-thank-big-button my-2 px-2 py-3 rounded-md text-center cursor-pointer text-base w-full"
            ref={node => {
              if (node)
                node.style.setProperty("background", `#174DD9`, "important");
            }}
            target="_blank"
          >
            <span
              ref={node => {
                if (node) node.style.setProperty("color", `white`, "important");
              }}
            >
              {" "}
              {currentLanguage && currentLanguage.share_on_facebook_text
                ? currentLanguage.share_on_facebook_text
                : "SHARE ON FACEBOOK"}
            </span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default DeskShareOptions;
